const e = {
  extends: "MegaMillions",
  style: {
    extraBall: {
      bg: "#fec524"
    }
  }
};
export {
  e as default
};
